<template>
  <v-row class="text-table pb-0" :class="{ off: nodeIndex % 2 !== 0 }">
    <template v-for="(column, index) in columns">
      <v-col
        class="no-padding"
        style="display: flex"
        cols="12"
        md
        :key="column"
        :class="{ 'text-actions mr-4': column === 'actions', 'dense-row': column === 'actions' && dense }"
      >
        <span v-if="index === 0 && enableCheckbox" style="position: relative; top: -10px">
          <v-checkbox
            :disabled="checkboxDisabled"
            v-model="checkbox"
            :value="isSelected(node)"
            hide-details
            :class="{ 'checkbox-disabled': checkboxDisabled }"
            @click="changeSelectedCheckbox(node, node.children ? node.children : [], nodeIndex), $emit('click')"
          ></v-checkbox>
        </span>

        <span v-if="column === 'progress' && type === 'AccountsReceivableShipperCargo'">
          <v-progress-linear
            :value="node.data.percentageDeliveryFinished"
            height="15"
            class="mt-2 progress"
            color="light-blue"
            striped
          >
            <small>
              <strong> {{ node.data.finishedDeliveries }}/{{ node.data.totalDeliveries }} </strong>
            </small>
          </v-progress-linear>
        </span>

        <span v-if="column === 'progress' && type !== 'AccountsReceivableShipperCargo'">
          <v-progress-linear
            :value="node.data.deliveryInfo.percentageDeliveryFinished"
            height="15"
            class="mt-2 progress"
            color="light-blue"
            striped
          >
            <small
              ><strong
                >{{ node.data.deliveryInfo.qtdDeliveryFinished }}/{{ node.data.deliveryInfo.qtdDelivery }}</strong
              ></small
            >
          </v-progress-linear>
        </span>

        <span v-if="column === 'nfeProgress'">
          <v-progress-linear
            :value="node.data.nfeInfo.percentageNfeFinished"
            height="15"
            class="mt-2 progress"
            color="light-blue"
            striped
          >
            <small
              ><strong>{{ node.data.nfeInfo.qtdNfeFinished }}/{{ node.data.nfeInfo.qtdNfe }}</strong></small
            >
          </v-progress-linear>
        </span>

        <span v-if="column === 'progressPaid' && type === 'AccountsReceivableShipperCargo'">
          <v-progress-linear
            :value="node.data.percentagePaidFinished"
            height="15"
            class="mt-2 progress"
            color="light-blue"
            striped
          >
            <small
              ><strong>{{ node.data.totalPaid }}/{{ node.data.finishedDeliveries }}</strong></small
            >
          </v-progress-linear>
        </span>

        <v-row v-if="column === 'actions' && type !== 'Ctes'" class="text-actions">
          <v-tooltip top v-if="enableDropdown">
            <template v-slot:activator="{ on, attrs }">
              <DropdownActions
                :itemsDropdown="itemsDropdown"
                @actionsDropdown="actionsDropdown"
                v-bind="attrs"
                v-on="on"
              ></DropdownActions>
            </template>
            <span>Mais ações</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <span class="pa-2" @click="openEdit(node.data)" v-if="type === 'Embarque'" v-bind="attrs" v-on="on">
                <PencilSVG />
              </span>
            </template>
            <span>Editar</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <span class="pa-2" @click="openDelete(node.data)" v-if="type === 'Embarque'" v-bind="attrs" v-on="on">
                <TrashSVG />
              </span>
            </template>
            <span>Deletar</span>
          </v-tooltip>

          <span
            @click="onExpand()"
            v-if="type != 'Nota Fiscal' && type !== 'Ctes' && type !== 'AccountsReceivableShipperNfe'"
          >
            <v-tooltip top v-if="node.open">
              <template v-slot:activator="{ on, attrs }">
                <v-icon large color="primary" v-bind="attrs" v-on="on"> mdi-chevron-up </v-icon>
              </template>
              <span>Retrair</span>
            </v-tooltip>

            <v-tooltip top v-if="!node.open">
              <template v-slot:activator="{ on, attrs }">
                <v-icon large v-bind="attrs" v-on="on"> mdi-chevron-down </v-icon>
              </template>
              <span>Expandir</span>
            </v-tooltip>
          </span>
        </v-row>

        <v-row v-if="column === 'actions' && type === 'Ctes'" class="pa-2">
          <span v-if="type === 'Ctes'">
            <v-tooltip top v-if="node.data.status === true">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on"> mdi-download </v-icon>
              </template>
              <span>Download</span>
            </v-tooltip>
          </span>
        </v-row>

        <span v-if="column === 'price' && type === 'Contas'">
          <slot name="price" :item="node.data[column]"> {{ node.data[column] }} - tttt </slot>
        </span>

        <span v-if="column === 'stops' && type === 'CargaAccounts'">
          <slot name="cargo-stop-details"></slot>
        </span>

        <span v-if="column === 'id' && type === 'Contas'">
          <slot name="boardingId" :item="node.data[column]">
            {{ node.data[column] }}
          </slot>
        </span>
        <span v-else-if="(column === 'costFreight' || column === 'totalNfes') && type === 'Entrega'">
          <TruncateDataWithTooltip
            :data="transformPrice(node.data[column])"
            :lengthDataToTruncate="lengthDataToTruncate"
          ></TruncateDataWithTooltip>
        </span>

        <span v-else-if="column === 'financialData' && type === 'Carga'">
          <div v-if="node.data.transhipmentId" class="d-flex flex-column">
            <div class="d-flex align-center">
              <v-icon size="23" class="mr-1"> mdi-cash-check</v-icon>
              <span> {{ transformPrice(node.data[column].amountPaid) }}</span>
            </div>
            <div class="d-flex align-center">
              <v-icon size="23" class="mr-1"> mdi-cash-minus </v-icon>
              <span> {{ transformPrice(node.data[column].amountToPay) }}</span>
            </div>
            <div class="d-flex align-center">
              <v-icon size="22" class="mr-1"> mdi-cash-multiple</v-icon>
              <span> {{ transformPrice(node.data[column].totalValue) }}</span>
            </div>
          </div>
        </span>
        <span v-else-if="column === 'shipmentfinancialData' && type === 'Embarque'">
          <div class="d-flex flex-column">
            <div class="d-flex align-center">
              <v-icon size="22" class="mr-1"> mdi-cash-fast</v-icon>
              <span> {{ transformPrice(node.data.advanceAmount) }}</span>
            </div>
            <div class="d-flex align-center">
              <v-icon size="22" class="mr-1"> mdi-truck-outline </v-icon>
              <span> {{ transformPrice(node.data.freightPrice) }}</span>
            </div>
            <div class="d-flex align-center">
              <v-icon size="22" class="mr-1"> mdi-cash</v-icon>
              <span> {{ transformPrice(node.data.totalPaid) }}</span>
            </div>
          </div>
        </span>

        <span v-else-if="column === 'transferred' && type === 'Carga'">
          <v-chip
            v-if="!node.data.isDirectDelivery"
            :color="getTrasferredChipColor(node.data[column])"
            style="color: white"
            >{{ getTrasferredChipLabel(node.data[column]) }}</v-chip
          >
        </span>

        <span v-else-if="column === 'receiptStatus'" class="d-flex flex-column align-start">
          <v-chip v-if="node.data.downloadedReceipt" class="pa-0" color="green" style="color: white">
            <v-avatar left class="pa-0 ma-0">
              <v-icon class="pa-0 ma-0">mdi-download</v-icon>
            </v-avatar>
            <div class="d-flex pr-2">
              <span>Download realizado</span>
            </div>
          </v-chip>
          <v-chip v-else class="pa-0" color="red" style="color: white">
            <v-avatar left class="pa-0 ma-0">
              <v-icon class="pa-0 ma-0">mdi-download</v-icon>
            </v-avatar>
            <div class="d-flex pr-2">
              <span>Download pendente</span>
            </div>
          </v-chip>

          <v-tooltip v-if="node.data.purgedReceipt" disabled bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-chip v-on="on" v-bind="attrs" class="pa-0" color="grey lighten-2">
                <v-avatar left class="pa-0 ma-0">
                  <v-icon class="pa-0 ma-0">mdi-clock-outline</v-icon>
                </v-avatar>
                <div class="d-flex pr-2">
                  <span>Canhoto expurgado</span>
                </div>
              </v-chip>
            </template>
          </v-tooltip>
          <v-tooltip v-if="node.data.daysToPurge" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-chip v-on="on" v-bind="attrs" class="pa-0" color="orange darken-1" style="color: white">
                <v-avatar left class="pa-0 ma-0">
                  <v-icon class="pa-0 ma-0">mdi-clock-outline</v-icon>
                </v-avatar>
                <div class="d-flex pr-2">
                  <span v-if="node.data.daysToPurge == '1'">Expurgo amanhã</span>
                  <span v-else>Expurgo em {{ node.data.daysToPurge }} dias </span>
                </div>
              </v-chip>
            </template>
            <span
              >Canhoto será expurgado em
              {{ format(add(new Date(), { days: node.data.daysToPurge }), 'P', { locale: pt }) }}
            </span>
          </v-tooltip>
        </span>

        <span
          v-else-if="
            column === 'canhotoType' &&
            (type === 'ParadaAccounts' ||
              type === 'AccountsReceivableShipperNfe' ||
              type === 'Nota Fiscal' ||
              type === 'Contas')
          "
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                @click="onClickReceiptFlag"
                v-bind="attrs"
                v-on="on"
                :color="getReceiptFlagColor(node.data[column])"
                style="color: white"
                >{{ getReceiptFlagTitle(node.data[column]) }}</v-chip
              >
            </template>
            <span>IR PARA GERENCIAMENTO</span>
          </v-tooltip>
        </span>

        <span v-else-if="column === 'advanceAmount' && type === 'Contas'">
          <TruncateDataWithTooltip
            :data="transformPrice(node.data[column])"
            :lengthDataToTruncate="lengthDataToTruncate"
          ></TruncateDataWithTooltip>
        </span>

        <span v-else-if="column === 'canhotoType'">
          <v-chip @click="onClickReceiptFlag" :color="getReceiptFlagColor(node.data[column])" style="color: white">{{
            getReceiptFlagTitle(node.data[column])
          }}</v-chip>
        </span>

        <span v-else-if="column === 'number' && type === 'Nota Fiscal'">
          <span>
            <TruncateDataWithTooltip
              :data="node.data[column]"
              :lengthDataToTruncate="lengthDataToTruncate"
            ></TruncateDataWithTooltip>

            <span class="open-box" @click="copy(node.data.accesskey)">
              <v-icon small> mdi-checkbox-multiple-blank-outline </v-icon>
              <div class="box-to-open">
                <v-card>
                  <v-card-text class="p-1" style="padding-top: 5px; padding-bottom: 5px">
                    Clique para copiar a chave de acesso:
                    {{ node.data.accesskey }}
                  </v-card-text>
                </v-card>
              </div>
            </span>
          </span>
        </span>
        <span v-else-if="column === 'completionDate' && type === 'Nota Fiscal'">
          <TruncateDataWithTooltip
            v-if="node.data[column] !== '01/01/1'"
            :data="node.data[column]"
            :lengthDataToTruncate="lengthDataToTruncate"
          ></TruncateDataWithTooltip>
        </span>

        <span v-else-if="column === 'numberCte' && type === 'Nota Fiscal'">
          <span>
            <TruncateDataWithTooltip
              :data="node.data[column]"
              :lengthDataToTruncate="lengthDataToTruncate"
            ></TruncateDataWithTooltip>

            <span class="open-box" @click="copy(node.data.accesskeyCte)">
              <v-icon small> mdi-checkbox-multiple-blank-outline </v-icon>
              <div class="box-to-open">
                <v-card>
                  <v-card-text class="p-1" style="padding-top: 5px; padding-bottom: 5px">
                    Clique para copiar chave de acesso da CTE:
                    {{ node.data.accesskeyCte }}
                  </v-card-text>
                </v-card>
              </div>
            </span>
          </span>
        </span>

        <span v-else-if="(column === 'number' || column === 'numberCte') && type === 'Entrega'">
          <span>
            <TruncateDataWithTooltip
              :data="node.data[column]"
              :lengthDataToTruncate="lengthDataToTruncate"
            ></TruncateDataWithTooltip>

            <span class="open-box" @click="copy(node.data.accesskeyCte)">
              <v-icon small> mdi-checkbox-multiple-blank-outline </v-icon>
              <div class="box-to-open">
                <v-card>
                  <v-card-text class="p-1" style="padding-top: 5px; padding-bottom: 5px">
                    Clique para copiar chave de acesso da CTE:
                    {{ node.data.accesskeyCte }}
                  </v-card-text>
                </v-card>
              </div>
            </span>
          </span>
        </span>

        <span
          v-else-if="(column === 'number' || column === 'numberCte') && type === 'AccountsReceivableShipperDelivery'"
        >
          <span>
            <TruncateDataWithTooltip
              :data="node.data[column]"
              :lengthDataToTruncate="lengthDataToTruncate"
            ></TruncateDataWithTooltip>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small @click="copy(node.data.accesskeyCte)" v-bind="attrs" v-on="on">
                  mdi-checkbox-multiple-blank-outline
                </v-icon>
              </template>

              <span class="d-block">Clique para copiar chave de acesso da CTE:</span>
              <span> {{ node.data.accesskeyCte }} </span>
            </v-tooltip>
          </span>
        </span>

        <span v-else-if="column === 'number' && type === 'AccountsReceivableShipperNfe'">
          <span>
            <TruncateDataWithTooltip
              :data="node.data[column]"
              :lengthDataToTruncate="lengthDataToTruncate"
            ></TruncateDataWithTooltip>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small @click="copy(node.data.accesskey)" v-bind="attrs" v-on="on">
                  mdi-checkbox-multiple-blank-outline
                </v-icon>
              </template>

              <span class="d-block"> Clique para copiar a chave de acesso:</span>
              <span> {{ node.data.accesskey }} </span>
            </v-tooltip>
          </span>
        </span>
        <span v-else-if="column === 'costFreight' && type === 'AccountsReceivableShipperDelivery'">
          <slot name="costFreight" :item="node.data[column]"> </slot>
        </span>
        <span v-else>
          <TruncateDataWithTooltip
            :data="node.data[column]"
            :lengthDataToTruncate="lengthDataToTruncate"
          ></TruncateDataWithTooltip>
        </span>
      </v-col>
    </template>
  </v-row>
</template>

<script>
import DropdownActions from '../Table/DropdownActions.vue';
import TruncateDataWithTooltip from '../Table/TruncateDataWithTooltip.vue';
import maskPrice from '@/utils/maskPrice.js';
import copyToClipboard from '../../utils/copyToClipboard';
import TrashSVG from '@/assets/img/trash.svg';
import PencilSVG from '@/assets/img/pencil.svg';
// import ViewSVG from '@/assets/img/view.svg';
import { add, format } from 'date-fns';
import { pt } from 'date-fns/locale';
export default {
  data: () => ({
    pt
  }),
  name: 'TableBodyRow',
  components: {
    TrashSVG,
    PencilSVG,
    // ViewSVG,
    DropdownActions,
    TruncateDataWithTooltip
  },
  computed: {
    checkbox: {
      get() {
        return this.node.selected;
      },
      set(value) {
        return value;
      }
    }
  },
  props: {
    node: {
      default: () => [],
      type: Object
    },
    nodeIndex: {
      default: () => 0,
      type: Number
    },
    columns: {
      default: () => [],
      type: Array
    },
    itemsDropdown: {
      default: () => [],
      type: Array
    },
    lengthDataToTruncate: {
      default: () => 10,
      type: Number
    },
    type: {
      default: () => '',
      type: String
    },
    enableCheckbox: {
      default: () => false,
      type: Boolean
    },
    checkboxDisabled: {
      default: () => false,
      type: Boolean
    },
    shipmentIndex: {
      default: () => 0,
      type: Number
    },
    cargoIndex: {
      default: () => 0,
      type: Number
    },
    stopIndex: {
      default: () => 0,
      type: Number
    },
    deliveryIndex: {
      default: () => 0,
      type: Number
    },
    enableDropdown: {
      default: () => false,
      type: Boolean
    },
    selectedCheckbox: {
      default: () => [],
      type: Array
    },
    dense: {
      default: false,
      type: Boolean
    }
  },
  methods: {
    add,
    format,
    onExpand() {
      this.$emit('onExpand');
    },
    copy(str) {
      copyToClipboard(str);
    },
    actionsDropdown(indexDropdown) {
      this.$emit('actionsDropdown', indexDropdown, this.node);
    },
    alignItensActions(column) {
      if (column == 'actions') return 'text-actions mr-4';
      else return;
    },
    onClickReceiptFlag() {
      this.$emit('receiptFlagClick');
    },
    getReceiptFlagColor(id) {
      const colors = {
        1: 'red',
        2: 'orange',
        3: 'green'
      };

      return colors[id] || 'red';
    },
    getReceiptFlagTitle(id) {
      const titles = {
        1: 'FALTA CANHOTO',
        2: 'CANHOTO NÃO VALIDADO',
        3: 'CANHOTO VALIDADO'
      };

      return titles[id] || 'FALTA CANHOTO';
    },
    getTrasferredChipLabel(isTransferred) {
      return isTransferred ? 'Transferido' : 'Não transferido';
    },
    getTrasferredChipColor(isTransferred) {
      return isTransferred ? 'green' : 'red';
    },
    changeSelectedCheckbox(item, children, nodeIndex) {
      switch (this.type) {
        case 'Embarque':
          this.$emit('changeCheckbox', item, children, nodeIndex, 0, 0, 0, 0);
          break;
        case 'Carga':
          this.$emit('changeCheckbox', item, children, this.shipmentIndex, nodeIndex, 0, 0, 0);
          break;
        case 'Parada':
          this.$emit('changeCheckbox', item, children, this.shipmentIndex, this.cargoIndex, nodeIndex, 0, 0);
          break;
        case 'Entrega':
          this.$emit(
            'changeCheckbox',
            item,
            children,
            this.shipmentIndex,
            this.cargoIndex,
            this.stopIndex,
            nodeIndex,
            0
          );
          break;
        case 'Nota Fiscal':
          this.$emit(
            'changeCheckbox',
            item,
            children,
            this.shipmentIndex,
            this.cargoIndex,
            this.stopIndex,
            this.deliveryIndex,
            nodeIndex
          );
          break;
        case 'Entregador':
          this.$emit('changeCheckbox', item, children, nodeIndex);
          break;
        case 'Contas':
          this.$emit('changeCheckbox', item, children, nodeIndex);
          break;
        case 'TransbordoAccounts':
          this.$emit('changeCheckbox', item, children, nodeIndex);
          break;
        case 'CargaAccounts':
          this.$emit('changeCheckbox', item, children, nodeIndex);
          break;
        case 'ParadaAccounts':
          this.$emit('changeCheckbox', item, children, nodeIndex);
          break;
        case 'Shipper':
          this.$emit('changeCheckbox', item, children, nodeIndex);
          break;
        case 'AccountsReceivableShipperCargo':
          this.$emit('changeCheckbox', item, children, nodeIndex);
          break;
        case 'AccountsReceivableShipperDelivery':
          this.$emit('changeCheckbox', item, children, nodeIndex);
          break;
        case 'Ctes':
          this.$emit('changeCheckbox', item, children, nodeIndex);
          break;
      }
    },
    isSelected(node) {
      return node.selected;
    },
    openDelete(node) {
      this.$emit('openDelete', node);
    },
    openEdit(node) {
      this.$emit('openEdit', node);
    },
    transformPrice(value) {
      return maskPrice(value);
    }
  }
};
</script>

<style lang="scss">
.text-actions {
  justify-content: flex-end;
}

.progress {
  width: 90px;
  margin-right: 7%;
  color: white;
}
.dense-row {
  max-width: 40px;
  width: 100%;
}
.checkbox-disabled {
  opacity: $checkbox-disabled-opacity;
}
</style>
